import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numeroInscricao'
})
export class NumeroInscricaoPipe implements PipeTransform {

   transform(value: string, args?: any): any {

      if (value) {
        value = value.replace(/(\d{3})(\d{4})/, '$1-$2');
  
        switch (value.length) {
          case 4:
          case 5:
          case 6:
          case 7:
            value = value.replace(/(\d{3})(\d{4})/, '$1-$2');
            break;
          default:
            return value;
        }

      }
      return value;
  }

}
